<script lang="ts" setup>
const props = withDefaults(
	defineProps<{
		icon?: string;
		iconColor?: string;
		size?: 'sidebar' | 'compact' | 'tile' | 'header' | 'list';
	}>(),
	{
		size: 'tile',
	},
);

const sizeClasses = {
	sidebar: {
		icon: 14,
		wrapper: 'size-5 rounded-sm',
	},
	compact: {
		icon: 16,
		wrapper: 'size-7 rounded-md',
	},
	list: {
		icon: 16,
		wrapper: 'size-8 rounded-md',
	},
	tile: {
		icon: 24,
		wrapper: 'size-11 rounded-md',
	},
	header: {
		icon: 28,
		wrapper: 'size-14 rounded-lg',
	},
} as const;
</script>

<template>
	<span
		class="flex shrink-0 items-center justify-center border border-default bg-white text-muted"
		:class="sizeClasses[props.size].wrapper"
	>
		<slot>
			<DIcon
				v-if="icon"
				:name="icon"
				:style="{ color: iconColor }"
				:size="sizeClasses[props.size].icon"
			/>
		</slot>
	</span>
</template>
